// Limites et messages d'erreur de l'upload Workspace (partagés par
// WorkspaceCreateModal et WorkspaceManageModal).
//
// Plafond réel : Cloud Run (HTTP/1) refuse toute requête de plus de 32 Mio
// avant même qu'elle n'atteigne le backend (413 sans en-têtes CORS, donc vu
// par le navigateur comme une simple erreur réseau). On garde une marge pour
// l'enveloppe multipart. Garder aligné avec MAX_FILE_SIZE_BYTES du backend
// (backend-flask/workspace_routes.py).
export const MAX_UPLOAD_FILE_BYTES = 30 * 1024 * 1024;
export const MAX_UPLOAD_FILE_LABEL = '30 Mo';
export const MAX_DOCS_PER_WORKSPACE = 500;

export function formatMegabytes(bytes) {
  return `${((bytes || 0) / 1024 / 1024).toFixed(1).replace('.', ',')} Mo`;
}

export function isTooLarge(file) {
  return ((file && file.size) || 0) > MAX_UPLOAD_FILE_BYTES;
}

export function tooLargeMessage(file) {
  return `Fichier trop volumineux (${formatMegabytes(file.size)}). `
    + `Taille maximum : ${MAX_UPLOAD_FILE_LABEL} par fichier. Découpez-le en plusieurs PDF.`;
}

// Traduit l'échec d'un upload en message lisible par l'utilisateur.
// `resp` : la Response fetch (si le serveur a répondu), `error` : l'exception
// levée par fetch (si la requête n'a pas abouti).
export async function uploadErrorMessage({ resp, error, file }) {
  if (!resp) {
    // Erreur réseau : c'est aussi la forme que prend un 413 de l'infra.
    if (isTooLarge(file)) return tooLargeMessage(file);
    console.error('upload network error', error);
    return 'Connexion interrompue pendant l\'envoi. Réessayez.';
  }

  let serverError = '';
  try {
    const body = await resp.json();
    serverError = (body && body.error) || '';
  } catch (e) {
    serverError = '';
  }

  if (resp.status === 413) return tooLargeMessage(file);
  if (resp.status === 401) return 'Session expirée. Reconnectez-vous puis réessayez.';
  if (resp.status === 404) return 'Workspace introuvable. Rouvrez-le puis réessayez.';
  if (resp.status === 409) {
    if (serverError.includes('workspace full')) {
      return `Workspace plein (${MAX_DOCS_PER_WORKSPACE} documents maximum).`;
    }
    return 'Indexation en cours : réessayez dans quelques minutes.';
  }
  if (resp.status === 400 && serverError.includes('unsupported file type')) {
    return 'Format non supporté (PDF, DOCX ou image uniquement).';
  }
  if (resp.status >= 500) return 'Erreur temporaire du serveur. Réessayez dans un instant.';
  return `Échec de l'envoi (code ${resp.status}). Réessayez.`;
}
